import { jsx as _jsx } from "react/jsx-runtime";
import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
export const marketplaceWidgetRoutes = {
    path: 'marketplace',
    children: [
        {
            path: 'apps/:appId/versions/:versionId/widgets/:widgetIdentifier',
            async lazy () {
                const { MarketplaceWidgetRoute } = await retryImportInsideRoutesDefinition(()=>import('./widgets'));
                return {
                    element: /*#__PURE__*/ _jsx(MarketplaceWidgetRoute, {})
                };
            }
        }
    ]
};
export const ldsRoutes = {
    path: 'lds',
    children: [
        {
            path: ':widgetIdentifier',
            async lazy () {
                const { LdsWidgetRoute } = await retryImportInsideRoutesDefinition(()=>import('./lds-widgets'));
                return {
                    element: /*#__PURE__*/ _jsx(LdsWidgetRoute, {})
                };
            }
        }
    ]
};
